module.exports = __webpack_public_path__ + "static/media/tooltip.5efc5dda.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Icons/tooltip.svg
// module id = 877
// module chunks = 21